import { useEffect, useState } from 'react';
import authToken from 'src/utils/auth';
import {
  SIGN_IN_CONFIRMATION as SIGN_IN_CONFIRMATION_ROUTE,
  HOME,
} from 'src/routes/routes';

export default (authorizationCode, targetUrl) => {
  const [redirectUrl, setRedirectUrl] = useState();

  useEffect(() => {
    const url = new URL(API_URL.replace('/graphql', '/oauth2/code'));
    url.search = new URLSearchParams({
      auth_code: authorizationCode,
    }).toString();
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
      .then(r => r.json())
      .catch(() => {
        setRedirectUrl(HOME);
      })
      .then(result => {
        if (result.error) {
          setRedirectUrl(HOME);
          return;
        }

        if (!result.mfaEnabled) {
          authToken(result);
  
          window.location.href = targetUrl;
        } else {
          setRedirectUrl(`${SIGN_IN_CONFIRMATION_ROUTE}?login=${result?.user?.email}`);
        }
      });
  }, []);

  return redirectUrl;
};
